import { Component, Input } from '@angular/core';

import { CompletionStatus } from '@completion/enums';

function coerceCompletionStatus(value: unknown): CompletionStatus {
  if (typeof value === 'number') {
    const numeric = value as number;
    const enumValues = Object.values(CompletionStatus).filter((v) => typeof v === 'number') as number[];
    return enumValues.includes(numeric) ? (numeric as unknown as CompletionStatus) : CompletionStatus.OS;
  }

  if (typeof value === 'string') {
    const v = value.trim().toUpperCase();
    switch (v) {
      case 'OK':
        return CompletionStatus.OK;
      case 'OS':
      case 'OPEN':
        return CompletionStatus.OS;
      case 'NA':
      case 'N/A':
        return CompletionStatus.NA;
      case 'PA':
        return CompletionStatus.PA;
      case 'PB':
        return CompletionStatus.PB;
      case 'PP':
        return CompletionStatus.PP;
      default:
        return CompletionStatus.OS;
    }
  }

  return CompletionStatus.OS;
}

@Component({
  selector: 'app-check-sheet-status',
  templateUrl: './check-sheet-status.component.html',
  styleUrls: ['./check-sheet-status.component.scss'],
  standalone: false,
})
export class CheckSheetStatusComponent {
  private readonly statusSymbols: Map<CompletionStatus, string> = new Map<CompletionStatus, string>([
    [CompletionStatus.PA, 'A'],
    [CompletionStatus.PB, 'B'],
    [CompletionStatus.PP, 'P'],
    [CompletionStatus.NA, 'N'],
    [CompletionStatus.OK, 'OK'],
    [CompletionStatus.OS, 'O'],
  ]);

  @Input({ transform: coerceCompletionStatus }) status: CompletionStatus = CompletionStatus.OS;
  @Input() label = '';
  @Input() isOffline = false;
  @Input() useSmall = false;

  get symbol(): string {
    const trimmedLabel = this.label?.trim();
    return trimmedLabel ? trimmedLabel : (this.statusSymbols.get(this.status) ?? '');
  }

  get showLightning(): boolean {
    const symbol = this.symbol.toUpperCase();
    return symbol === 'A' || symbol === 'B';
  }
}
